export const ENTERPRISE = "ENTERPRISE"
export const REGIONAL = "REGIONAL"
export const SUB_REGIONAL = "SUB_REGIONAL"

export const getAdministratorLevelName = (administratorLevel) => {
    switch (administratorLevel) {
        case ENTERPRISE:
            return "Enterprise";
        case REGIONAL:
            return "Region";
        case SUB_REGIONAL:
            return "Subregion";
        default:
            return "";
    }
}
